import { ApiModelStrategy, FrameworkContractOut, ModelStrategyTypes } from '../services/rest-api/rest-api';
import { InstrumentCategories } from './charts/charts';
import { RadiosKeyValue } from './radio-input-group/radio-input-group';

export const defaultRiskLevels = [1, 2, 3, 4, 5, 6];
export const defaultInstrumentRiskLevels = [1, 2, 3, 4, 5, 6, 7];

export enum charTypes {
  'INSTRUMENTS' = 1,
  'REGION' = 2,
  'HISTORY' = 3,
}

export const availableInvestmentPeriods = [
  {
    value: '1',
    key: 'weekly',
    disabled: false,
  },
  {
    value: '4',
    key: 'monthly',
    disabled: false,
  },
  {
    value: '12',
    key: 'quarterly',
    disabled: false,
  },
];

export const newPortfolioConfig = {
  oneTimeDepositMin: 500,
  regularDepositMin: 500,
  investmentNameMaxLength: 32,
  investmentNameMinLength: 3,
  timeOfInvestmentInit: 20,
}

export const instrumentCategoryColors: Record<keyof typeof InstrumentCategories | string, string> = {
  EQUITY: '#E52713',
  BOND: '#781900',
  ALTERNATIVE: '#858585',
  COMODITY: '#3B3B3B',
  CASH: '#008000',
  MONEY: '#fc5017',
  REAL_ESTATE: '#4CBB17',
  LEVERAGED: '#32CD32',
  CRYPTOCURRENCY: '#2F7EEE',
  MULTI_ASSET: '#FFD700',
}

export const randomColors: string[] = [
  '#262626',
  '#3fa535',
  '#b5b5b5',
]

export const maxInvestmentLength = 40; // years

export enum SortDirections {
  HIGH_RISK = 'HIGH_RISK',
  LOW_RISK = 'LOW_RISK'
};

export const lowestOptimizedWidthBreakpoint = 290; //px
export const smallPhoneWidthBreakpoint = 360; //px
export const regularPhoneWidthBreakpoint = 420; //px
// https://getbootstrap.com/docs/5.0/layout/breakpoints/
export const tabletWidthBreakpoint = 576; //px
export const desktopWidthBreakpoint = 768; //px
export const largeDesktopWidthBreakpoint = 992; //px
export const xlDesktopWidthBreakpoint = 1200; //px
// export const largeScreenWidthBreakpoint = 1400; //px

export const PUBLIC_ROUTES = {
  PUBLIC_INSTRUMENTS: 'prehled-instrumentu', // todo - translate routes
  LOGIN: 'login',
  DIP_REDIRECT: 'dip-redirect',
  COOKIE_TEXT: 'cookie-text',
  ADDITION_REDIRECT: 'addition-redirect',
  BLOG_PREVIEW: 'blog/preview',
  CLIENT_ADDITION_REDIRECT: 'client-addition-redirect',
  EMAIL_VERIFICATION: 'email-verification/confirm',
}

export const CUSTOM_STRATEGY_GLOBAL_INDEX: ApiModelStrategy = {
  modelStrategyId: -1,
  uiOrder: 0.5,
  name: 'staticPortfolios.worldIndexes',
  description: '',
  imageUrl: '/assets/images/thematic_portfolios/world.jpg',
  iconUrl: '/assets/icons/globe.svg',
  translate: true,
  type: ModelStrategyTypes.THEMATIC_STRATEGY,
}

export const CLIENT_PEEK_ROUTE = 'client-peek';
export const NEW_CLIENT_ROUTE = 'new-client';
export const BLOG_ROUTE = 'blog';

export const NEW_CLIENT_ID = NaN;

export const NEW_CLIENT_CONTRACT: FrameworkContractOut = {
  frameworkContractId: NaN,
  frameworkContractNumber: '',
  dip: false,
  inLiquidation: false,
  unsignedAdditions: [],
  invSignDate: new Date().toISOString().split('T')[0],
  opfFeeImplementation: false,
}

// new client does not have real contracts but DIP switch is wanted
export const NEW_CLIENT_AVAILABLE_CONTRACTS = [
  NEW_CLIENT_CONTRACT,
  {
    ...NEW_CLIENT_CONTRACT,
    dip: true,
  },
];

export const EfektikaInstrumentWeights = {
  singleEfektikaInstrumentWeight: 98,
  efektikaCashMax: 2,
}

export const CLIENT_REDIRECT_AFTER_AUTH_ROUTES = [
  BLOG_ROUTE,
];

export const EFEKTIKA_PDF = 'Podminky_EFEKTIKA';

export const DATE_OF_OPF_TRANSFERS = '2025-09-01';

export const availableWithdrawalPeriods: RadiosKeyValue[] = [
  {
    value: 'MONTHLY',
    key: 'MONTHLY',
    disabled: false,
  },
  {
    value: 'QUARTERLY',
    key: 'QUARTERLY',
    disabled: false,
  },
];
